export default {"src":"/_next/static/media/ic-tip.f082809d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};